
<div class="view-nomination-page">

  <!-- INTESTAZIONE -->
  <div class="page-header">

    <div class="page-header-icon">
      <i class="pi pi-megaphone"></i>
    </div>

    <div class="page-header-text">
      <h1>Candidatura spontanea</h1>
      <p>
        Consulta le candidature disponibili e verifica
        lo stato delle tue richieste.
      </p>
    </div>

  </div>

  <!-- PANNELLO PRINCIPALE -->
  <div class="nomination-panel">

    <div class="panel-heading">

      <div class="panel-heading-left">
        <i class="pi pi-list"></i>

        <div>
          <h2>
            {{ showConfirmation ? 'Conferma candidatura' : 'Candidature disponibili' }}
          </h2>

          <p>
            {{
              showConfirmation
                ? 'Verifica la tua scelta prima di procedere.'
                : 'Visualizza le opportunità e lo stato delle candidature.'
            }}
          </p>
        </div>
      </div>

      <span
        class="nomination-counter"
        *ngIf="!showConfirmation && loaded && nominations.length > 0"
      >
        {{ nominations.length }}
        {{ nominations.length === 1 ? 'candidatura' : 'candidature' }}
      </span>

    </div>

    <div class="panel-content">

      <!-- CARICAMENTO -->
      <div
        class="loading-state"
        *ngIf="!loaded && !showConfirmation"
      >
        <i class="pi pi-spin pi-spinner"></i>
        <span>Caricamento candidature...</span>
      </div>

      <!-- CONFERMA -->
      <ng-container *ngIf="showConfirmation">

        <div class="confirmation-card">

          <div class="confirmation-icon">
            <i class="pi pi-question-circle"></i>
          </div>

          <h3>
            Confermi di voler presentare questa candidatura?
          </h3>

          <p class="confirmation-description">
            Stai per inviare la tua candidatura per la seguente posizione:
          </p>

          <div
            class="confirmation-position"
            *ngIf="confirming"
          >
            <i class="pi pi-briefcase"></i>
            <span>{{ confirming.title }}</span>
          </div>

          <div class="confirmation-actions">

            <p-button
              label="Annulla"
              icon="pi pi-times"
              severity="danger"
              [outlined]="true"
              (onClick)="cancel()"
            ></p-button>

            <p-button
              label="Conferma"
              icon="pi pi-check"
              severity="success"
              (onClick)="submit(confirming!)"
            ></p-button>

          </div>

        </div>

      </ng-container>

      <!-- ELENCO CANDIDATURE -->
      <ng-container *ngIf="!showConfirmation && loaded">

        <div
          class="nomination-list"
          *ngIf="nominations.length > 0"
        >

          <div
            class="nomination-card"
            *ngFor="let nomination of nominations"
          >

            <div class="nomination-card-header">

              <div class="nomination-card-icon">
                <i class="pi pi-briefcase"></i>
              </div>

              <div class="nomination-card-title">
                <h3>{{ nomination.title }}</h3>
                <span>Candidatura spontanea</span>
              </div>

            </div>

            <div class="nomination-card-body">

              <ng-container [ngSwitch]="nomination.submitted?.status">

                <!-- ACCETTATA -->
                <div
                  class="nomination-status"
                  *ngSwitchCase="NominationStatus.ACCEPTED"
                >
                  <div class="status-icon status-success">
                    <i class="pi pi-check-circle"></i>
                  </div>

                  <div class="status-content">
                    <p-tag severity="success">
                      <span class="tag-text">
                        Candidatura spontanea accettata
                      </span>
                    </p-tag>
                  </div>
                </div>

                <!-- CANCELLATA -->
                <div
                  class="nomination-status"
                  *ngSwitchCase="NominationStatus.CANCELLED"
                >
                  <div class="status-icon status-info">
                    <i class="pi pi-info-circle"></i>
                  </div>

                  <div class="status-content">
                    <p-tag severity="info">
                      <span class="tag-text">
                        Candidatura spontanea cancellata come da richiesta
                      </span>
                    </p-tag>
                  </div>
                </div>

                <!-- NON RICHIESTA -->
                <div
                  class="nomination-status"
                  *ngSwitchCase="NominationStatus.NOT_REQUESTED"
                >
                  <div class="status-icon status-available">
                    <i class="pi pi-check"></i>
                  </div>

                  <div class="status-content">
                    <p class="available-description">
                      Puoi presentare la tua candidatura per questa posizione.
                    </p>

                    <p-button
                      label="Candidati"
                      icon="pi pi-megaphone"
                      severity="success"
                      (onClick)="showConfirm(nomination)"
                    ></p-button>
                  </div>
                </div>

                <!-- IN ATTESA -->
                <div
                  class="nomination-status"
                  *ngSwitchCase="NominationStatus.PENDING"
                >
                  <div class="status-icon status-warning">
                    <i class="pi pi-clock"></i>
                  </div>

                  <div class="status-content">

                    <p-tag severity="warning">
                      <span class="tag-text">
                        Candidatura spontanea in attesa di approvazione
                      </span>
                    </p-tag>

                    <div class="pending-information">

                      <p>
                        La sua richiesta verrà gestita entro
                        le prossime 48 ore.
                      </p>

                      <p>
                        Se si desidera annullare la propria candidatura
                        occorre comunicarlo tramite mail a:
                        <strong>pistoia@faisa-cisal.org</strong>.
                      </p>

                    </div>

                  </div>
                </div>

                <!-- ALTRA POSIZIONE -->
                <div
                  class="nomination-status"
                  *ngSwitchCase="NominationStatus.REQUESTED_ANOTHER"
                >
                  <div class="status-icon status-info">
                    <i class="pi pi-info-circle"></i>
                  </div>

                  <div class="status-content">
                    <p-tag severity="info">
                      <span class="tag-text">
                        Candidatura presentata per un'altra posizione
                      </span>
                    </p-tag>
                  </div>
                </div>

                <!-- RIFIUTATA -->
                <div
                  class="nomination-status"
                  *ngSwitchCase="NominationStatus.REJECTED"
                >
                  <div class="status-icon status-danger">
                    <i class="pi pi-times-circle"></i>
                  </div>

                  <div class="status-content">
                    <p-tag severity="danger">
                      <span class="tag-text">
                        Candidatura spontanea rifiutata
                        per mancanza dei requisiti
                      </span>
                    </p-tag>
                  </div>
                </div>

              </ng-container>

            </div>

          </div>

        </div>

        <!-- NESSUNA CANDIDATURA -->
        <div
          class="empty-state"
          *ngIf="nominations.length === 0"
        >

          <div class="empty-state-icon">
            <i class="pi pi-inbox"></i>
          </div>

          <h3>
            Al momento non è possibile effettuare alcuna candidatura
          </h3>

          <p>
            Non sono presenti candidature disponibili.
          </p>

        </div>

      </ng-container>

    </div>

  </div>

</div>
